
import React, { Fragment, useState } from 'react'
import { useTranslation } from "react-i18next"
import { Container, Grid, useMediaQuery } from '@material-ui/core'
import './resume.css'

const ResumeView = (props) => {
  const { t, i18n } = useTranslation()

  return (

    <Container spacing={4} lg={12} md={12} sm={12} xs={12} style={{ maxWidth: '100%' }}>
      <div className='container-payment'>
        <Grid lg={12} md={12} sm={12} xs={12} className='globalContainerStylesResume'>
          <Grid lg={3} md={3} sm={12} xs={12} className='container-spacing-resume'>
            <div className='items-payment-information-resume' >
              {props.promotion === true ? <p className='resume-plan-name'>{t('planProcessView.promotionPlan')}</p> : <p className='resume-plan-name'>{t('planProcessView.individualPlan')}</p>}
              <span>{props.firstName + " " + props.firstLastName + " " + props.secondLastName}</span><br></br>
              <span>{props.rfc}</span><br></br>
              <span>{props.cellphoneNumber}</span><br></br>
              {props.street && <span>{props.street + " " + props.colony + " " + props.township + " " + props.state + " " + props.zipCode}</span>}
            </div>
          </Grid>
          <Grid lg={4} md={4} sm={12} xs={12} className='container-spacing-resume'>
            <div className={props.selectedPlanPricingId[0] === Number(process.env.REACT_APP_PLAN_STANDAR_PLUS) ? 'item-plan-resumeHardDark' : 'items-plan-resume  selected-plan-resume'}>
              <div className='container-detail-plan'>
                {props.assignedPlans[0] ?
                  <Fragment>
                    <p className=' item-title-plan-resume selected-resume'>
                      {props.assignedPlans[0].name}
                    </p>
                    {/* <span className={props.selectedPlanPricingId[0] === Number(process.env.REACT_APP_PLAN_STANDAR_PLUS) ? 'item-plan-hardDark' : 'item-num-plan-resume selected-price-resume'}>
                    {props.assignedPlans[0].id === 8 ? t('resumeView.businessPlan') : props.assignedPlans[0].monthlyTransaction}
                  </span> */}
                    <p className='item-resume-plan selected-resume'>
                      {props.promotion ? `Incluye ${props.assignedPlans[0].monthlyTransaction} créditos` : props.assignedPlans[0].id === 8 ? '' : `Incluye ${props.assignedPlans[0].monthlyTransaction} créditos`}
                    </p>
                  </Fragment>
                  :
                  null}
                {props.assignedPackage[0] ?
                  <Fragment>
                    {/* <div className={props.selectedPlanPricingId[0] === Number(process.env.REACT_APP_PLAN_STANDAR_PLUS) ? 'item-plan-resumeHardDark' : 'items-plan-resume  selected-plan-resume'}> */}
                    <p className=' item-title-plan-resume selected-resume'>
                      {props.assignedPackage[0].name}
                    </p>
                    {/* <span className={props.selectedPlanPricingId[0] === Number(process.env.REACT_APP_PLAN_STANDAR_PLUS) ? 'item-plan-hardDark' : 'item-num-plan-resume selected-price-resume'}>
                      {props.assignedPackage[0].monthlyTransaction}
                    </span> */}
                    <p className='item-resume-plan selected-resume'>
                      {`Incluye ${props.assignedPackage[0].monthlyTransaction} créditos`}
                    </p>
                    {/* </div> */}
                  </Fragment>
                  :
                  null}
              </div>
            </div>

          </Grid>
          {props.promotion ? null : <Grid lg={4} md={4} sm={12} xs={12} className='container-spacing-resume'>
            <div className='container-detail-pay'>
              <div>
                <p className='resume-text-method'>{t('planProcessView.payMethod')}</p>
                <p className='spaces'>{props.card ? t('planProcessView.debitCard') : props.transfer ? t('planProcessView.transfer') : t('planProcessView.a3TratoDirecto')}</p>
              </div>
              <div >
                <p className='resume-text-method'> {t('planProcessView.startPlan')}</p>
                <p className='spaces' >{props.card ? props.dateResume : t('planProcessView.undefined')}</p>
              </div>
            </div>
          </Grid>}
        </Grid>
      </div>
      <Grid lg={12} md={12} sm={12} xs={12} className='globalContainerStylesResume'>
        <div className='resume-text-form-pay'>
          <p>
            {t("planProcessView.messageFromGovo.pt1")}
            {props.card ? t('planProcessView.debitCardFinalMessage') : props.transfer ? t('planProcessView.transferFinalMessage') : t('planProcessView.a3TratoDirectoFinalMessage')}
            {t("planProcessView.messageFromGovo.pt2")}
          </p>
          <p>{t("planProcessView.messageFromGovo.contractedPackage")}<span className='plan-text'>{(props.assignedPackage[0]) ? (props.assignedPlans[0]) ? (props.assignedPlans[0] && props.assignedPackage[0]) ? props.assignedPlans[0].name + ' y ' + props.assignedPackage[0].name : null : props.assignedPackage[0].name : props.assignedPlans[0].name}</span></p>
          <p>{t("planProcessView.messageFromGovo.pt3")}</p>
          <p>{t("planProcessView.messageFromGovo.pt4")}</p>
          <p>{t("planProcessView.messageFromGovo.pt5")}</p>
          <p>{t("planProcessView.messageFromGovo.pt6")}</p>
          <p>{t("planProcessView.messageFromGovo.pt7")}</p>
          <span>{t("planProcessView.messageFromGovo.pt8")}</span>
        </div>
      </Grid>
    </Container>


  )
}

export { ResumeView as default }